/* eslint-disable */
export default {
  "dirty": false,
  "raw": "v1.15.31-1-ga2b3bc4a",
  "hash": "ga2b3bc4a",
  "distance": 1,
  "tag": "v1.15.31",
  "semver": {
    "options": {
      "loose": false,
      "includePrerelease": false
    },
    "loose": false,
    "raw": "v1.15.31",
    "major": 1,
    "minor": 15,
    "patch": 31,
    "prerelease": [],
    "build": [],
    "version": "1.15.31"
  },
  "suffix": "1-ga2b3bc4a",
  "semverString": "1.15.31+1.ga2b3bc4a"
};
